import { render, staticRenderFns } from "./xian-other.vue?vue&type=template&id=8cb221fe&scoped=true&"
import script from "./xian-other.vue?vue&type=script&lang=js&"
export * from "./xian-other.vue?vue&type=script&lang=js&"
import style0 from "./xian-other.vue?vue&type=style&index=0&id=8cb221fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb221fe",
  null
  
)

component.options.__file = "xian-other.vue"
export default component.exports